import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { ConfigureStore } from "./redux/store/ConfigureStore";
import React from "react";
const store = ConfigureStore();

const Root = ({ children }) => <Provider store={store}>{children}</Provider>;

Root.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.object.isRequired,
};

export default Root;
